import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../../contexts/PageContext';

import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import { GroupPropTypesShape } from '../../../Includes/GroupPropsShape';
import { LOGIN_LAYOUT } from '../../../Login/LoginLayoutComponent/LoginLayoutComponent';
/* eslint-disable import/no-named-as-default */
import ReactRouterLink from '../../ReactRouterLink';

import './GroupCTA.scss';

export class GroupCTA extends React.PureComponent {
    handleJoin = () => {
        const ctaText = this.renderCTAText();

        if (ctaText === 'Join group') {
            EmitMetric({
                misc_event_type: 'join-group-click',
                misc_event_count: 1,
                community_group_hash: this.props.group.hash,
                user_id: this.props.pageProps.session.id,
            });
        } else {
            EmitMetric({
                misc_event_type: 'join-group-request-click',
                misc_event_count: 1,
                community_group_hash: this.props.group.hash,
                user_id: this.props.pageProps.session.id,
            });
        }
    };

    renderCTAText = () => {
        const { userRelation, group, isMember } = this.props;
        const { privacySetting } = group;

        const canPost = isMember();

        const requestedMembership = userRelation.role === 'requested';

        if (requestedMembership) {
            return 'Applied';
        }

        if (canPost) {
            return 'Post now';
        }

        if (!canPost && privacySetting !== 'open') {
            return 'Request to join';
        }

        return 'Join group';
    };

    postButtonHandler = () => {
        const { pageProps, modalTrigger, group } = this.props;
        const { unifiedPostBox } = pageProps.featureFlags;

        if (unifiedPostBox) {
            if (!window || !document) return;
            const upb = document.getElementById('unified-post-box');
            if (!upb) return;

            const editor = document.querySelector(
                '.component-UnifiedPostBox-PostBoxCTA'
            );

            if (editor) {
                editor.click();
            }

            const scrollTop = upb.offsetTop;
            window.scrollTo({ top: scrollTop - 65, behavior: 'smooth' });
        } else {
            const groupData = {
                id: group.hash,
                name: group.name,
                image: group.logo,
                type: 'Group',
            };

            modalTrigger('CreateContentPopup', {
                defaultPostLocation: groupData,
            });
        }
    };

    renderButton = () => {
        const {
            userRelation,
            group,
            wrapAuth,
            pageProps,
            isLoggedIn,
            isMember,
        } = this.props;

        const { frontendRouting } = pageProps;

        const canPost = isMember();
        const notMember = !isMember() && !userRelation.role;
        const hasRequestedMembership = userRelation.role === 'requested';

        if (!isLoggedIn()) {
            const loginMetrics = {
                login_trigger: 'join-group',
            };

            return wrapAuth(
                'Groups',
                <button className="cta-btn" type="button">
                    {this.renderCTAText()}
                </button>,
                loginMetrics,
                null,
                LOGIN_LAYOUT
            );
        }

        if (hasRequestedMembership) {
            return (
                <button className="cta-btn applied" disabled type="button">
                    {this.renderCTAText()}
                </button>
            );
        }

        if (userRelation.role === 'invited') {
            return (
                <button
                    className="cta-btn"
                    type="button"
                    onClick={this.props.acceptInvitation}
                >
                    Accept Invitation
                </button>
            );
        }

        if (canPost) {
            return (
                <button
                    className="cta-btn"
                    type="button"
                    onClick={this.postButtonHandler}
                >
                    {this.renderCTAText()}
                </button>
            );
        }

        if (notMember) {
            if (frontendRouting) {
                return (
                    <ReactRouterLink to="/join">
                        <button
                            className="cta-btn"
                            type="button"
                            onClick={this.handleJoin}
                        >
                            {this.renderCTAText()}
                        </button>
                    </ReactRouterLink>
                );
            }
            return (
                <a href={`/groups/${group.hash}/join`} className="cta-btn">
                    {this.renderCTAText()}
                </a>
            );
        }
    };

    render() {
        return (
            <div className="component-Groups-Elements-GroupCTA">
                {this.renderButton()}
            </div>
        );
    }
}

GroupCTA.propTypes = {
    /**
     * Group information
     */
    group: PropTypes.shape(GroupPropTypesShape).isRequired,
    /**
     * User's relation to the group
     */
    userRelation: PropTypes.shape({
        role: PropTypes.string,
    }).isRequired,
    /**
     * Page props to determine FE routing
     */
    /* eslint-disable react/forbid-prop-types */
    pageProps: PropTypes.object.isRequired,
    /**
     * Triggers the modal for a new post
     */
    modalTrigger: PropTypes.func.isRequired,
    /**
     * function to check whether user is logged in
     */
    isLoggedIn: PropTypes.func.isRequired,
    /**
     * Function to check if user is a group member or superadmin
     */
    isMember: PropTypes.func,
    /**
     * Function to accept an invitation to a group
     */
    acceptInvitation: PropTypes.func.isRequired,
    wrapAuth: PropTypes.func.isRequired,
};
GroupCTA.defaultProps = {
    isMember: () => false,
};

export default (props) => (
    <PageConsumer>
        {({ modalTrigger, pageProps, wrapAuth, isLoggedIn }) => (
            <GroupCTA
                {...props}
                modalTrigger={modalTrigger}
                wrapAuth={wrapAuth}
                pageProps={pageProps}
                isLoggedIn={isLoggedIn}
            />
        )}
    </PageConsumer>
);
